import React, { useCallback } from 'react';
import classnames from 'classnames';
import BillingInputComponent from '../../template-blocks/billing-input/billing-input-component';
import billingInputTypes from '../../template-blocks/billing-input/billing-input-types';

import './quote-header-component.scss';

export default function QuoteHeaderComponent({ id, orderNumber, orderDate, onOrderDetailsChange, previewMode }) {
  const onBillingInputChange = useCallback(
    (inputId, inputData) => {
      if (inputData.data === '') return;

      onOrderDetailsChange(inputId, inputData.data);
    },
    [onOrderDetailsChange]
  );

  return (
    <div className={classnames('quote-header-component', 'pdf-row', { preview: previewMode })}>
      <div className="header-section quote-number">
        <span className="input-title number">#</span>
        <div className="billing-input-wrapper number">
          <BillingInputComponent
            id="orderNumber"
            type={billingInputTypes.text}
            withTitle={false}
            previewMode={previewMode}
            onChange={onBillingInputChange}
            value={orderNumber || ''}
          />
        </div>
      </div>
      <div className="header-section quote-date">
        <span className="input-title date">Date issued:</span>
        <div className="billing-input-wrapper date">
          <BillingInputComponent
            id="orderDate"
            type={billingInputTypes.date}
            withTitle={false}
            previewMode={previewMode}
            onChange={onBillingInputChange}
            value={orderDate}
          />
        </div>
      </div>
    </div>
  );
}
